import React from "react";

export default function Container({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}): React.ReactElement {
  const defaultClassName = "col-start-2 col-span-10";
  const cn = className || defaultClassName;
  return (
    <div className="grid grid-cols-12 gap-4">
      <div className={cn}>{children}</div>
    </div>
  );
}
